// @ts-ignore
import VueCryptojs from "vue-cryptojs";
import Vue from "vue";

Vue.use(VueCryptojs);
